import React from 'react';
import { useTranslation } from 'react-i18next';
import { ControlledInputText } from 'components';

export const CampaignName = ({
  ...props
}: {
  [key: string]: any;
}): JSX.Element => {
  const { t } = useTranslation();
  return (
    <ControlledInputText
      name='name'
      label={t('campaign.name', 'Nazwa')}
      {...props}
    />
  );
};
